var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.86265 9.13741H1.9344C1.61518 9.13741 1.34579 9.02762 1.12622 8.80805C0.906658 8.58849 0.796875 8.31911 0.796875 7.99991C0.796875 7.68071 0.906658 7.41132 1.12622 7.19176C1.34579 6.97219 1.61518 6.86241 1.9344 6.86241H6.86265V1.93416C6.86265 1.61494 6.97243 1.34555 7.192 1.12598C7.41157 0.906414 7.68095 0.796631 8.00015 0.796631C8.31935 0.796631 8.58873 0.906414 8.8083 1.12598C9.02787 1.34555 9.13765 1.61494 9.13765 1.93416V6.86241H14.0659C14.3851 6.86241 14.6545 6.97219 14.8741 7.19176C15.0936 7.41132 15.2034 7.68071 15.2034 7.99991C15.2034 8.31911 15.0936 8.58849 14.8741 8.80805C14.6545 9.02762 14.3851 9.13741 14.0659 9.13741H9.13765V14.0657C9.13765 14.3849 9.02787 14.6543 8.8083 14.8738C8.58873 15.0934 8.31935 15.2032 8.00015 15.2032C7.68095 15.2032 7.41157 15.0934 7.192 14.8738C6.97243 14.6543 6.86265 14.3849 6.86265 14.0657V9.13741Z",
    fill: "#DCF8DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.0cd3bc2fd69c304fab19785e27b3a1f9.svg";
export { ForwardRef as ReactComponent };